export default "//static.tradera.net/touchweb/static/output/images/trustly.a19a6b61.svg";